import { slash, bell, cloud, crack, fist, footprint, palm, speed, sprite, star, target, waves } from '../kit';
import { C, mix, type Pix } from '../pix';
import { registerIcons } from '../store';
import { statusEmblem } from '../emblems';

/** หมัดระฆังก้อง (เส้าหลิน, hard): golden vajra fists and palms, the temple bell, the lion's roar. */

const GOLD_SKIN = '#ffcf5a';
const GOLD_LINE = '#c8862a';
const HALO = '#fff0a8';

/** A guardian lion's head, roaring (14×12). */
function lionHead(p: Pix, x: number, y: number): void {
  sprite(
    p,
    x,
    y,
    [
      '..m.mmmmm.m...',
      '.mmmmmmmmmmm..',
      'mmmsssssssmmm.',
      'mmsseessseesm.',
      'mmssssssssssm.',
      'mmsssnnnnsssmm',
      'mmssddddddssm.',
      'mmssdwwwwdssm.',
      'mmmsddddddsmm.',
      '.mmmssssssmm..',
      '..mmmmmmmmm...',
      '...m.m.m.m....',
    ],
    { m: '#e8782a', s: GOLD_SKIN, e: C.ink, n: '#c8502a', d: '#7a1a1a', w: C.white },
  );
}

/** A rock that a blow splits. */
function boulder(p: Pix, x: number, y: number, w: number, h: number): void {
  p.ell(x + w / 2, y + h / 2, w / 2, h / 2, '#9a8c7c');
  p.ell(x + w / 2 + 2, y + h / 2 - 2, w / 3, h / 3, '#b8ab98');
}

registerIcons('skill', {
  // A golden fist driven straight out, the air bursting round it.
  'ar-strike': (p) => {
    for (let k = 0; k < 8; k++) {
      const a = (k * Math.PI) / 4;
      p.line(
        16 + Math.cos(a) * 11,
        16 + Math.sin(a) * 11,
        16 + Math.cos(a) * 14,
        16 + Math.sin(a) * 14,
        HALO,
      );
    }
    fist(p, 10, 10, GOLD_SKIN, { shade: GOLD_LINE });
  },
  // A thousand-buddha palm flung out as a print of gold.
  'ar-palm': (p) => {
    speed(
      p,
      10,
      [
        [9, 7],
        [15, 9],
        [21, 6],
        [26, 8],
      ],
      HALO,
    );
    palm(p, 13, 8, GOLD_SKIN, { lines: GOLD_LINE });
    p.ring(19, 15, 12, 12, HALO, -0.9, 0.9);
  },
  // The golden bell that covers the body.
  'ar-bell': (p) => {
    p.ring(17, 16, 13, 13, HALO, -2.8, 0.3);
    bell(p, 17, 8, 16, C.gold, { band: GOLD_LINE });
  },
  // A low sweeping kick that throws up the dust.
  'ar-sweep': (p) => {
    slash(p, 16, 12, 14, 0.35, 2.8, HALO, 3);
    // The sweeping leg, low to the ground: orange trouser and a bare foot.
    p.thick(6, 18, 20, 23, '#e8902a', 4);
    sprite(p, 19, 20, ['.sss..', 'ssssss', 'sssss.', '..ss..'], { s: GOLD_SKIN });
    cloud(p, 2, 30, 8, '#d8c8a8');
    cloud(p, 22, 30, 8, '#d8c8a8');
    statusEmblem(p, 'slow', 2, 4);
  },
  // A fist splits a boulder in two.
  'ar-break': (p) => {
    boulder(p, 4, 10, 18, 15);
    crack(
      p,
      [
        [13, 10],
        [11, 15],
        [14, 18],
        [12, 25],
      ],
      C.ink,
      2,
    );
    fist(p, 15, 2, GOLD_SKIN, { shade: GOLD_LINE });
    for (const [x, y] of [
      [4, 8],
      [22, 14],
      [6, 27],
    ] as const)
      p.rect(x, y, 2, 2, '#b8ab98');
  },
  // The lion's roar, rolling out in rings.
  'ar-lion': (p) => {
    lionHead(p, 2, 10);
    waves(p, 13, 16, 6, 4, HALO, 0.9, 3);
  },
  // One step of the arhat, a footprint stamped in gold onto the foe.
  'ar-step': (p) => {
    speed(
      p,
      13,
      [
        [12, 5],
        [18, 8],
        [24, 6],
      ],
      HALO,
    );
    footprint(p, 13, 11, GOLD_SKIN);
    footprint(p, 14, 12, GOLD_SKIN);
    target(p, 25, 7, 3, C.white);
  },
  // The Tathagata's palm comes down from the sky inside a ring of light.
  'ar-buddha': (p) => {
    p.ring(16, 13, 11, 11, HALO);
    p.ring(16, 13, 9, 9, mix(HALO, C.gold, 0.5));
    palm(p, 4, 3, GOLD_SKIN, { k: 2, flipY: true, lines: GOLD_LINE });
    star(p, 26, 6, 2, C.white);
  },
});
